<template>
    <transition name="app-switcher">
        <div class="app-switcher-overlay" ref="appSwitcher">
            <div class="app-switcher-content">
                <div v-for="app in apps" :key="app.appKey" class="app-box">
                    <div class="app-link" @click="handleAppClick(app)">
                        <a-icon
                            :type="app.antIcon"
                            :class="['app-icon', { 'is-ant-icon': app.antIcon }]"
                            v-if="app.antIcon"
                            fill="red"
                        />
                        <i
                            class="material-icons"
                            :class="['app-icon', { 'is-material-icon': app.materialIcon }]"
                            v-if="app.materialIcon"
                            >{{ app.materialIcon }}</i
                        >
                        <component :is="getIcon(app)" class="custom-app-icon" fill="red" v-else />
                        <div class="app-name">{{ app.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import menu from "../utils/menu";
import FormIcon from "./svg/Form.vue";
import TicketIcon from "./svg/Ticket.vue";
import CalendarIcon from "./svg/Calendar.vue";
import ChatbotIcon from "./svg/Chatbot.vue";
import MailIcon from "./svg/Mail.vue";
import TaskIcon from "./svg/icons/TaskIcon.vue";
import Comments from "./svg/Comment";
export default {
    components: {
        FormIcon,
        TicketIcon,
        TaskIcon,
        CalendarIcon,
        ChatbotIcon,
        MailIcon,
        Comments,
    },
    props: {},
    data() {
        return {
            cancels: [],
            apps: [
                {
                    appKey: "chat",
                    title: this.$t("settings.Chat"),
                    icon: "comments",
                    route: "/chat",
                    superAdminPageKey: "customer-chat",
                },
                {
                    appKey: "chatbot",
                    title: this.$t("chatbotv2.chatbot"),
                    icon: "ChatbotIcon",
                    route: "/chatbot",
                    superAdminPageKey: "customer-chatbot",
                },
                {
                    appKey: "tables",
                    title: this.$t("tables.tables"),
                    antIcon: "table",
                    route: "/tables",
                    superAdminPageKey: "tables",
                },
                {
                    appKey: "automations",
                    title: this.$t("automation.automations"),
                    icon: "atomic-power",
                    route: "/automations",
                    superAdminPageKey: "automations",
                },
                {
                    appKey: "tasks",
                    title: this.$t("calendar.tasks"),
                    icon: "TaskIcon",
                    route: "/tasks",
                    superAdminPageKey: "customer-tasks",
                },
                {
                    appKey: "ticket",
                    title: this.$t("ticket.tickets"),
                    icon: "TicketIcon",
                    route: "/ticket",
                    superAdminPageKey: "customer-ticket",
                },
                {
                    appKey: "mails",
                    title: this.$t("message.mails"),
                    antIcon: "mail",
                    route: "/mails",
                    superAdminPageKey: "customer-mails",
                },
                {
                    appKey: "form",
                    title: this.$t("form.forms"),
                    icon: "FormIcon",
                    route: "/form",
                    superAdminPageKey: "customer-forms",
                },
                {
                    appKey: "calendar",
                    title: this.$t("tables.calendar"),
                    icon: "CalendarIcon",
                    route: "/calendar",
                    superAdminPageKey: "customer-calendar",
                },
                {
                    appKey: "drive",
                    title: "Drive",
                    antIcon: "cloud-server",
                    route: "/drive",
                    superAdminPageKey: "customer-drive",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        allowedApps() {
            let appSwitcherApps = menu(this).filter(
                (item) =>
                    item.enabled &&
                    !item.isAdmin &&
                    [
                        "tables",
                        "automations",
                        "form",
                        "ticket",
                        "tasks",
                        "calendar",
                        "chatbot",
                        "mails",
                        "chat",
                    ].includes(item.path.split("/")[1])
            );

            if (!this.isAdmin) {
                appSwitcherApps = appSwitcherApps.filter((app) => {
                    if (this.user.role.isRoot) return true;
                    return !!this.user.role.permissions.find((userPermission) => {
                        if (!app.permission) return true;
                        if (Array.isArray(app.permission)) {
                            return app.permission.includes(userPermission.name);
                        }
                        return userPermission.name === app.permission;
                    });
                });
            }

            return appSwitcherApps;
        },
    },
    methods: {
        isAllowed(key) {
            if (key === "customer-drive") return true;
            return this.allowedApps.find((app) => app.superAdminPageKey === key);
        },
        close(target) {
            console.log("[AppSwitcher] close", target);
            this.$emit("close");
        },
        getIcon(app) {
            return app.icon;
        },
        handleKeydown(event) {
            if (event.key === "Escape") {
                this.close("esc");
            }
        },
        handleClick(event) {
            const appSwitcher = this.$refs.appSwitcher;
            if (!appSwitcher.contains(event.target)) {
                this.close("click");
            }
        },
        handleAppClick(app) {
            if (this.isAllowed(app.superAdminPageKey)) {
                this.$router.push(app.route);
                this.close("navigation");
            } else {
                this.$message.error("Bu uygulamaya geçiş izininiz yoktur, yöneticinizle iletişime geçiniz");
            }
        },
    },
    mounted() {
        const handleKeydown = this.handleKeydown;
        const handleClick = this.handleClick;
        window.addEventListener("keydown", handleKeydown);
        window.addEventListener("click", handleClick);
        this.cancels.push(() => {
            window.removeEventListener("keydown", handleKeydown);
            window.removeEventListener("click", handleClick);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
};
</script>

<style lang="scss">
.app-switcher-overlay {
    position: fixed;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(79, 70, 229, 0.15);
    z-index: 1000;
    top: 56px;
    left: 62px;
    border-top-left-radius: 20px;
    padding: 24px;
    backdrop-filter: blur(10px);
}

.app-switcher-enter-active {
    animation: zoomIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.app-switcher-leave-active {
    animation: explode 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes zoomIn {
    0% {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

@keyframes explode {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(1.1) rotate(2deg);
    }
}

.app-switcher-content {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    max-width: 450px;

    svg {
        fill: red;
        path {
            fill: red;
        }
    }

    .app-box {
        flex: 0 0 calc(50% - 8px);
        padding: 10px;
        background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
        border: 1px solid rgba(229, 231, 235, 0.5);
        border-radius: 12px;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &::before {
            content: "";
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: linear-gradient(
                45deg,
                transparent 0%,
                rgba(255, 255, 255, 0.2) 45%,
                rgba(255, 255, 255, 0.8) 50%,
                rgba(255, 255, 255, 0.2) 55%,
                transparent 100%
            );
            transform: rotate(-45deg);
            animation: lightBeam 3s infinite;
        }

        &:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 24px rgba(79, 70, 229, 0.15);
            border-color: rgba(79, 70, 229, 0.2);
            background: linear-gradient(135deg, #ffffff 0%, #eef2ff 100%);

            .app-icon,
            .custom-app-icon {
                transform: scale(1.1);
            }

            .app-name {
                background: linear-gradient(90deg, #4f46e5, #7c3aed);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .app-icon,
        .custom-app-icon {
            font-size: 32px;
            margin-bottom: 12px;
            transition: transform 0.3s ease;

            :deep(svg) {
                width: 100%;
                height: 100%;

                path {
                    fill: url(#rainbow-gradient) !important;
                }
            }

            &.is-ant-icon {
                :deep(.anticon) {
                    background: linear-gradient(135deg, #ff6b6b, #4ecdc4, #45b7d1, #96c93d, #ffbe0b);
                    -webkit-background-clip: text;
                    background-clip: text;
                    -webkit-text-fill-color: transparent;

                    svg {
                        fill: currentColor !important;

                        path {
                            fill: currentColor !important;
                        }
                    }
                }
            }
        }

        .custom-app-icon {
            width: 32px;
            height: 32px;
        }

        .app-name {
            font-size: 16px;
            font-weight: 600;
            color: #374151;
            transition: all 0.3s ease;
        }

        .app-link {
            text-decoration: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: inherit;
            position: relative;
            z-index: 1;
            cursor: pointer;
        }

        // SVG gradient tanımı
        :deep(defs) {
            linearGradient#rainbow-gradient {
                stop {
                    &:nth-child(1) {
                        stop-color: #ff6b6b;
                    }

                    &:nth-child(2) {
                        stop-color: #4ecdc4;
                    }

                    &:nth-child(3) {
                        stop-color: #45b7d1;
                    }

                    &:nth-child(4) {
                        stop-color: #96c93d;
                    }

                    &:nth-child(5) {
                        stop-color: #ffbe0b;
                    }
                }
            }
        }

        // Her iki tür ikon için de animasyon
        .app-icon,
        .custom-app-icon {
            animation: rainbow 5s ease infinite;
        }
    }
}

@keyframes lightBeam {
    0% {
        transform: translate(-100%, -100%) rotate(-45deg);
    }
    100% {
        transform: translate(100%, 100%) rotate(-45deg);
    }
}

@keyframes rainbow {
    0% {
        filter: hue-rotate(0deg);
    }
    100% {
        filter: hue-rotate(360deg);
    }
}
</style>
